import type {
	DisableSftpPgpKeyResponse,
	GenerateSftpPgpKeyResponse,
	GetSftpPgpKeyResponse,
} from "@performyard/service-contracts";

import request from "./internal-base-request";

const BASE = "/v1/sftp-pgp-keys";

export const getSftpPgpKey = async (): Promise<GetSftpPgpKeyResponse> => {
	const [data] = await request<GetSftpPgpKeyResponse>(BASE);
	return data;
};

/** Also the rotate call — generating again supersedes the company's current active key. */
export const generateSftpPgpKey = async (): Promise<GenerateSftpPgpKeyResponse> => {
	const [data] = await request<GenerateSftpPgpKeyResponse>(BASE, { method: "POST" });
	return data;
};

export const disableSftpPgpKey = async (): Promise<DisableSftpPgpKeyResponse> => {
	const [data] = await request<DisableSftpPgpKeyResponse>(BASE, { method: "DELETE" });
	return data;
};
